import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  ADDRESS_COUNTRY,
  INDUSTRY_CODE,
  SECTOR_CODE,
} from 'constants/formFields';
import { DEFAULT_OPTION } from 'constants/general';
import { specificCreateSchema } from 'utils/validators';

import type { TSpecificCreateSchema } from 'utils/validators';
import type ICreateIndustryForm from '../interfaces/ICreateIndustryForm';

const useCreateIndustryForm = ({ isPageLoading }: ICreateIndustryForm) => {
  const {
    control,
    handleSubmit,
    formState: { isDirty, isLoading },
    reset,
    setError,
    getValues,
    watch,
    setValue,
    resetField,
  } = useForm<TSpecificCreateSchema>({
    mode: 'onSubmit',
    resolver: yupResolver(specificCreateSchema),
    defaultValues: {
      [ADDRESS_COUNTRY]: DEFAULT_OPTION,
      [INDUSTRY_CODE]: DEFAULT_OPTION,
      [SECTOR_CODE]: [],
    },
  });

  useEffect(() => {
    if (!isPageLoading) {
      reset();
    }
  }, [reset, isPageLoading]);

  const fieldsName = Object.keys(getValues());

  return {
    control,
    handleSubmit,
    isDirty,
    reset,
    isLoading,
    setError,
    fieldsName,
    watch,
    setValue,
    resetField,
  };
};

export default useCreateIndustryForm;
